import {apiClient} from "@services/dataSource/lib/api";
import {API_URL} from "@app/constants/apiUrlInfo";
import {AbstractPayloadEntity, ResponsePageableEntity} from "@services/entities/baseEntity";
import {
    BrandManualDashboardPayload,
    BrandNoticeDashboardPayload,
    BrandRegisteredUserDashboardPayload,
    BrandRegisteredUserGraphDashboardPayload,
    BrandUsageCompanyDashboardPayload,
    BrandUsageShopDashboardPayload,
    CafeDeviceDashboardPayload,
    CafeNoticeDashboardPayload,
    CafeOperationDashboardPayload,
    CafeOrderByTimeDashboardPayload,
    DiningCongestionUpdatePayload,
    DiningCourseStatusDashboardPayload,
    DiningDeviceDashboardPayload,
    DiningMealSoldOutUpdatePayload,
    DiningOperationDashboardPayload,
    DiningOrderByTimeDashboardPayload,
    DiningShopStatusDashboardPayload,
} from "@services/entities/dashboardEntity";
import {ManualEntity} from "@services/entities/manualEntity";
import {NoticeEntity} from "@services/entities/boardEntity";


// NEW :: (cafe) manual get Api - dashboard
export const CafeManualDashboardGetApi = async <T extends AbstractPayloadEntity<ResponsePageableEntity<ManualEntity>>>(): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.cafe.manual);
}

// NEW :: (cafe) operation get Api - dashboard
export const CafeOperationDashboardGetApi = async <T extends CafeOperationDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.cafe.operation, {params});
}

// NEW :: (cafe) notice get list Api - dashboard
export const CafeNoticeDashboardGetApi = async <T extends CafeNoticeDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.cafe.notice, {params});
}

// NEW :: (cafe) order by time get Api - dashboard
export const CafeOrderByTimeDashboardGetApi = async <T extends CafeOrderByTimeDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.cafe.orderByTime, {params});
}

// NEW :: (cafe) device get Api - dashboard
export const CafeDeviceDashboardGetApi = async <T extends CafeDeviceDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(`${API_URL.dashboard.cafe.device}/${params.shopId}`);
}

// NEW :: (dining) shop state get Api - dashboard (운영상태 및 운영시간)
export const DiningShopStateDashboardGetApi = async <T extends DiningShopStatusDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.dining.shopState, {params});
    // return await apiClient.get(`${API_URL.dashboard.dining.shopState}/${params?.shopId}`);
}

// NEW :: (dining) operation get Api - dashboard (운영현황)
export const DiningOperationDashboardGetApi = async <T extends DiningOperationDashboardPayload>(params: T): Promise<T['response']> => {
    if (params) {
        return await apiClient.get(API_URL.dashboard.dining.operation, {params});
    } else {
        return Promise.reject('NO PARAMS');
    }
}

// NEW :: (dining) courseStatus get Api - dashboard (코스별 메뉴정보)
export const DiningCourseStatusDashboardGetApi = async <T extends DiningCourseStatusDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.dining.courseStatus, {params});
}

// NEW :: (dining) orderByTime get Api - dashboard (시간대별 결제건 추이)
export const DiningOrderByTimeDashboardGetApi = async <T extends DiningOrderByTimeDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.dining.orderByTime, {params});
}

// NEW :: (dining) device get Api - dashboard (디바이스 현황)
export const DiningDeviceDashboardGetApi = async <T extends DiningDeviceDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(`${API_URL.dashboard.dining.device}/${params?.shopId}`);
}

// NEW :: (dining) manual get Api - dashboard (메뉴얼)
export const DiningManualDashboardGetApi = async <T extends AbstractPayloadEntity<ResponsePageableEntity<ManualEntity>>>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.dining.manual);
}

// NEW :: (dining) notice get Api - dashboard (공지사항)
export const DiningNoticeDashboardGetApi = async <T extends AbstractPayloadEntity<ResponsePageableEntity<NoticeEntity>>>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.dining.notice, {params});
}


// NEW :: (dining) congestion put Api - dashboard (혼잡도 업데이트)
export const DiningCongestionDashboardPutApi = async <T extends DiningCongestionUpdatePayload>(data: T): Promise<T['response']> => {
    const tempData = Object.assign({}, data);
    delete tempData.mealCourseId;

    return await apiClient.put(`${API_URL.dashboard.dining.congestionStateUpdate}/${data?.mealCourseId}`, tempData);
}

// NEW :: (dining) course sold out put Api - dashboard (식단 품절 처리 업데이트)
export const DiningCourseSoldOutDashboardPutApi = async <T extends DiningMealSoldOutUpdatePayload>(data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.dashboard.dining.courseSoldOutUpdate, data);
}


//(brand) usage shop get Api - dashboard (브랜드 매장별 등록 및 사용)
export const BrandUsageShopDashboardGetApi = async <T extends BrandUsageShopDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.usageShop, {params});
}
//(brand) usage company get Api - dashboard (브랜드 법인별 등록 및 사용현황)
export const BrandUsageCompanyDashboardGetApi = async <T extends BrandUsageCompanyDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.usageCompany, {params});
}
//(brand) notice get Api - dashboard (브랜드 공지사항)
export const BrandNoticeDashboardGetApi = async <T extends BrandNoticeDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.notice, {params});
}
//(brand) manual get Api - dashboard (브랜드 메뉴얼)
export const BrandManualDashboardGetApi = async <T extends BrandManualDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.manual, {params});
}

//(brand) registered User get Api - dashboard (브랜드 임직원 등록현황)
export const BrandRegisteredUserDashboardApi = async <T extends BrandRegisteredUserDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.registered, {params});
}

//(brand) registered User get Api - dashboard (브랜드 임직원 등록현황)
export const BrandRegisteredUserGraphDashboardApi = async <T extends BrandRegisteredUserGraphDashboardPayload>(params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.dashboard.brand.graph, {params});
}